import { supabase } from "@/integrations/supabase/client";

export type ListingEventType =
  | "view"
  | "detail_click"
  | "message_click"
  | "purchase_request"
  | "save";

// Cached pause flag — refreshed every 60s to avoid hitting the DB per event.
let cachedPaused: boolean | null = null;
let cachedAt = 0;
const TTL_MS = 60_000;

async function isPaused(): Promise<boolean> {
  const now = Date.now();
  if (cachedPaused !== null && now - cachedAt < TTL_MS) return cachedPaused;
  try {
    const { data } = await (supabase as any).rpc("are_listing_events_paused");
    cachedPaused = !!data;
    cachedAt = now;
  } catch {
    cachedPaused = false;
  }
  return cachedPaused ?? false;
}

/**
 * Fire-and-forget logger for listing interaction events.
 * Errors are swallowed silently — analytics must never break the UI.
 * Skipped entirely while insights are paused (admin-controlled).
 */
export async function logListingEvent(
  listingId: string,
  eventType: ListingEventType,
): Promise<void> {
  try {
    if (await isPaused()) return;
    const { data: auth } = await supabase.auth.getUser();
    const userId = auth?.user?.id ?? null;
    await (supabase as any).from("listing_events").insert({
      listing_id: listingId,
      user_id: userId,
      event_type: eventType,
    });
  } catch {
    // ignore
  }
}
